<template>
  <svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><rect width="24" height="24" rx="4" fill="currentColor"/></svg>
</template>

<script>
  export default {
    name: 'StopIcon'
  }
</script>
